import React, { useState, useEffect } from "react";
import { ToastContainer } from "react-toastify";
import Dialog from "@mui/material/Dialog";
// import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
// import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { poppinsCustomTheme } from "../../Styles/GlobalStyles/PoppinsTheme";
import { ThemeProvider } from "@mui/material/styles";
import Slide from "@mui/material/Slide";
import {
  DialogButton,
  DialogGreyOutlinedButton,
  GreyOutlinedButton,
} from "../Button/CustomButton";
import { colors } from "../../Styles/GlobalStyles/Variables";
import CloseIcon from "@mui/icons-material/Close";
import { useSelector, useDispatch } from "react-redux";
import LoadingButton from "@mui/lab/LoadingButton";
// import generalFunc from "../../Utils/generalFunc";
import {
  Button,
  Divider,
  FormControl,
  IconButton,
  Skeleton,
  TextField,
  Typography,
} from "@mui/material";
import HorizontalLinearStepper from "./HorizontalTabs";
import { Box } from "@mui/system";
// import Iconify from "../Dashboard/Iconify";
import Image from "./Images/image3.png";
import ViewandEditForm from "./ViewandEditForm";
import { EditIcon } from "../MuiDataTableTheme/MuiDataTableTheme";
import SaveAsIcon from "@mui/icons-material/SaveAs";
import { StyledDivider } from "../Divider/StyledDivider";
// import styled from "@emotion/styled";
import {
  StyledDialogActions,
  StyledDialogTitle,
  StyledLeftBox,
  StyledRightBox,
} from "./dialogStyles/DialogStyles";
import {
  emptyCorpsMember,
  // fetchBusinessManagement,
  // fetchTotalBusinessManagement,
  restoreBusinessInitial,
  updateBusinessManagement,
} from "../../Actions";
import { errors } from "../../Utils/ErrorMessages/businessmgt";
import validators from "../../Utils/Validators";
// const getSkillState = (state) => state.skillsReducer;
const getUsersState = (state) => state.usersReducer;
const getBusinessState = (state) => state.businessReducer;


const sourceOfFundsArr = ['Loan', 'Grant', 'Personal']

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
const getCMState = (state) => state.usersReducer;
export default function AddNewBusinessDialog({
  openNewBusinessDialog,
  handleClose,
  formType,
  handleOpenEditBusinessDialog,
  singleBusinessData,
  isClosedDialog,
  resetState,
}) {
  const ToastStyle = {
    backgroundColor: "#d56b66",
    color: colors.white,
  };

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const dispatch = useDispatch();
  const initialFormValues = {
    businessManagementId: 0,
    stateCode: "",
    cmName: "",
    businessName: "",
    email: "",
    phoneNumber: "",
    sourceOfFund: 0,
    staffStrength: 0,
    streetAddress: "",
    stateId: 0,
    lgaId: 0,
    state: {},
    lgas: [],
  };
  const initialFormState = {
    businessNameError: false,
    businessNameErrorMsg: "",
    emailAddressError: false,
    emailAddressErrorMsg: "",
    phoneNumberError: false,
    phoneNumberErrorMsg: "",
    phoneNumberConfirmError: false,
    phoneNumberConfirmErrorMsg: "",
    staffStrengthError: false,
    staffStrengthErrorMsg: "",
    stateOfResidenceError: false,
    stateOfResidenceErrorMsg: "",
    sourceOfFundsError: false,
    sourceOfFundsErrorMsg: "",
    streetAddressError: false,
    streetAddressErrorMsg: "",
    inputError: false,
    inputErrorMsg: "",
    /*  lgaError: false,
    lgaErrorMsg: "Select a state before choosing LGA", */
  };
  // const [error, setError] = useState(false);
  // const [helperText, setHelperText] = useState("");
  const [formValues, setFormValues] = useState({ ...initialFormValues });
  const [loadingButton, setLoadingButton] = useState(false);
  // const [disable, setDisable] = useState(colors.primaryGreen);
  const [isFoundCM, setIsFoundCM] = useState(false);
  const [isError, setIsError] = useState(false);
  const { 
    corpsmemberDetails, 
    // isLoading 
  } = useSelector(getCMState);
  const { loadingUpdated } = useSelector(getBusinessState);
  const { authUser } = useSelector(getUsersState);

  const [checked, setChecked] = useState("");
  const [values, setValues] = useState({ label: "", value: 0 });
  const [lgaValues, setLgaValues] = useState({ label: "", value: 0 });
  const [formStates, setFormStates] = useState(initialFormState);
  const [datas, setDatas] = useState("");
  const [exCM, setExCM] = useState({});
  const [showSkeleton, setShowSkeleton] = useState(true);

  const resetFoundCM = () => {
    setIsFoundCM(false);
  };

  useEffect(() => {
    if (corpsmemberDetails?.data !== null) {
      setExCM(corpsmemberDetails?.data);
    } else {
      setIsFoundCM(false);
    }
  }, [corpsmemberDetails]);

  useEffect(() => {
    if (Object.keys(singleBusinessData)?.length !== 0) {
      setDatas(singleBusinessData);
      setShowSkeleton(false);
    } else {
      setShowSkeleton(true);
    }
  }, [singleBusinessData]);

  const showError = () => {
    setIsError(true);
  };
  const showNoError = () => {
    setIsError(false);
  };
  useEffect(() => {
    if (datas) {
      setFormValues({
        ...formValues,
        businessManagementId: datas.id,
        stateCode: datas?.cmName,
        cmName: datas?.cmName,
        businessName: datas?.businessName,
        email: datas?.email,
        phoneNumber: datas?.phoneNumber,
        sourceOfFund: sourceOfFundsArr.findIndex(el => el === datas?.sourceOfFund),
        staffStrength: datas?.staffStrength,
        streetAddress: datas?.streetAddress,
        isActive: datas?.isActive,
        state: datas?.state?.state,
        lgas: datas?.state?.lga,
        stateId: datas?.state?.stateID || "",
        lgaId: datas?.state?.lgaid || "",
      });
    }
  }, [datas]);

  useEffect(() => {
    if (datas.state !== null && datas.state !== undefined) {
      setValues({
        ...values,
        label: datas?.state?.state,
        value: datas?.state?.stateID,
      });
    }
    if (datas?.state?.lga !== null && datas?.state?.lga !== undefined) {
      setLgaValues({
        ...lgaValues,
        label: datas?.state?.lga,
        value: datas?.state?.lgaid,
      });
    }
  }, [datas]);

  const updateValue = (value) => {
    setFormValues({
      ...formValues,
      state: value,
      stateId: value.value,
    });
    setValues({
      ...values,
      label: value.label,
      value: value.value,
    });
  };

  const updateLgaValue = (value) => {
    setFormValues({
      ...formValues,
      lgas: value,
      lgaId: value.value,
    });
    setLgaValues({
      ...lgaValues,
      label: value.label,
      value: value.value,
    });
  };

  const stateHandler = (event, val) => {
    if (event) {
      setLgaValues({ label: "", value: 0 });
      setFormValues({
        ...formValues,
        stateId: val.value,
      });
    }
  };
  const lgaHandler = (event, val) => {
    if (event) {
      setFormValues({
        ...formValues,
        lgaId: val.value,
      });
    }
  };
  const handleBusinessUpdate = (event) => {
    const { name, value, checked } = event.target;
    let newValue = Number.parseInt(value);
    
    if (name === "isActive") {
      newValue = checked;
      setChecked(newValue);
    }
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: newValue,
    }));

    switch (name) {
      case "businessName":
        if (newValue === "") {
          setFormStates({
            ...formStates,
            businessNameError: true,
            businessNameErrorMsg: errors.businessName,
          });
        } else {
          setFormStates({
            ...formStates,
            businessNameError: false,
            businessNameErrorMsg: "",
          });
        }
        break;
      case "email":
        if (newValue === "") {
          setFormStates({
            ...formStates,
            emailAddressError: true,
            emailAddressErrorMsg: errors.emailAddress,
          });
        } else {
          setFormStates({
            ...formStates,
            emailAddressError: false,
            emailAddressErrorMsg: "",
          });
        }
        break;
      case "phoneNumber":
        if (newValue === "") {
          setFormStates({
            ...formStates,
            phoneNumberError: true,
            phoneNumberErrorMsg: errors.phoneNumber,
          });
        } else {
          setFormStates({
            ...formStates,
            phoneNumberError: false,
            phoneNumberErrorMsg: "",
          });
        }
        break;
      case "staffStrength":
        if (newValue === "") {
          setFormStates({
            ...formStates,
            staffStrengthError: true,
            staffStrengthErrorMsg: errors.staffStrength,
          });
        } else {
          setFormStates({
            ...formStates,
            staffStrengthError: false,
            staffStrengthErrorMsg: "",
          });
        }
        break;
      case "streetAddress":
        if (newValue === "") {
          setFormStates({
            ...formStates,
            streetAddressError: true,
            streetAddressErrorMsg: errors.location,
          });
        } else {
          setFormStates({
            ...formStates,
            streetAddressError: false,
            streetAddressErrorMsg: "",
          });
        }
        break;
      case "state":
        if (newValue === 0) {
          setFormStates({
            ...formStates,
            stateOfResidenceError: true,
            stateOfResidenceErrorMsg: errors.location,
          });
        } else {
          setFormStates({
            ...formStates,
            stateOfResidenceError: false,
            stateOfResidenceErrorMsg: "",
          });
        }
        break;
      case "lga":
        if (newValue === 0) {
          setFormStates({
            ...formStates,
            lgaError: true,
            lgaErrorMsg: errors.location,
          });
        } else {
          setFormStates({
            ...formStates,
            lgaError: false,
            lgaErrorMsg: "",
          });
        }
        break;
      default:
        break;
    }
  };

  const handleBlurEmail = (event) => {
    let newValue = event.target.value;
    newValue = event.target.value.trim();
    if (!validators.isValidEmail(newValue)) {
      setFormStates({
        ...formStates,
        emailAddressError: true,
        emailAddressErrorMsg:
          "Please enter a valid email or clear your selection",
      });
      return false;
    }
    setFormStates({
      ...formStates,
      emailAddressError: false,
      emailAddressErrorMsg: "",
    });
  };
  const handleBlurPhoneNumber = (event) => {
    let newValue = event.target.value;
    newValue = event.target.value.trim();
    if (!validators.isPhoneLength(newValue)) {
      setFormStates({
        ...formStates,
        phoneNumberError: true,
        phoneNumberErrorMsg:
          "Please enter a valid phone number or clear your selection",
      });
      return false;
    } else if (newValue === "") {
      setFormStates({
        ...formStates,
        phoneNumberError: true,
        phoneNumberErrorMsg: "Please fill in phone number",
      });
    }
    setFormStates({
      ...formStates,
      phoneNumberError: false,
      phoneNumberErrorMsg: "",
    });
  };
  const handleFormUpdate = () => {
    const { state, lgas, ...subMittedFormValues } = formValues;
    if (formStates.emailAddressError === true) {
      setFormStates({
        ...formStates,
        emailAddressError: true,
        emailAddressErrorMsg:
          "Please enter a valid email or clear your selection",
      });
    } else if (formStates.phoneNumberError === true) {
      setFormStates({
        ...formStates,
        phoneNumberError: true,
        phoneNumberErrorMsg:
          "Please enter a valid phone number or clear your selection",
      });
    } else {
      if (Object.values(subMittedFormValues).every((value) => value !== "")) {
        setLoadingButton(true);
        dispatch(updateBusinessManagement(subMittedFormValues));
      } else {
        if (
          formValues.businessName === "" ||
          formValues.email === "" ||
          formValues.phoneNumber === "" ||
          formValues.staffStrength === 0 ||
          formValues.streetAddress === "" ||
          formValues.stateId === 0 ||
          formValues.lgaId === 0
        ) {
          setFormStates({
            ...formStates,
            businessNameError: formValues.businessName === "",
            businessNameErrorMsg:
              formValues.businessName === "" ? errors.businessName : "",
            emailAddressError: formValues.email === "",
            emailAddressErrorMsg:
              formValues.email === "" ? errors.emailAddress : "",
            phoneNumberError: formValues.phoneNumber === "",
            phoneNumberErrorMsg:
              formValues.phoneNumber === "" ? errors.phoneNumber : "",
            staffStrengthError: formValues.staffStrength === 0,
            staffStrengthErrorMsg:
              formValues.staffStrength === 0 ? errors.staffStrength : "",
            streetAddressError: formValues.streetAddress === "",
            streetAddressErrorMsg:
              formValues.streetAddress === "" ? errors.location : "",
            stateOfResidenceError: formValues.stateId === 0,
            stateOfResidenceErrorMsg:
              formValues.stateId === 0 ? errors.location : "",
            lgaError: formValues.lgaId === 0,
            lgaErrorMsg: formValues.lgaId === 0 ? errors.location : "",
          });
        }
      }
    }
  };

  useEffect(() => {
    if (loadingButton && !loadingUpdated) {
      setLoadingButton(false);
    }
    return () => {
      dispatch(restoreBusinessInitial());
    };
  }, [loadingButton, loadingUpdated]);

  function resetForm() {
    setFormValues({
      ...formValues,
      name: "",
    });
  }

  const handleEdit = () => {
    handleOpenEditBusinessDialog();
  };
  const handleIsFoundCM = () => {
    setIsFoundCM(true);
  };
  const handleResetFoundCM = () => {
    setIsFoundCM(false);
    dispatch(emptyCorpsMember());
  };
  const handleCloseDialog = () => {
    handleResetFoundCM();
    handleClose();
    setFormStates({ ...initialFormState });
    setIsError(true);
    setShowSkeleton(true);

  };

  /*  useEffect(() => {
    if (Object.keys(exCM)?.length === 0) {
      setIsFoundCM(false);
    }
  }, [exCM]); */

  return (
    <ThemeProvider theme={poppinsCustomTheme}>
      <Dialog
        fullWidth={true}
        fullScreen={fullScreen}
        maxWidth={"md"}
        open={openNewBusinessDialog}
        TransitionComponent={Transition}
        keepMounted
        aria-labelledby="draggable-dialog-title"
        PaperProps={{
          style: { borderRadius: 20, overflow: "hidden", height: "100%" },
        }}
      >
        <Box
          height="100%"
          display="flex"
          flexDirection="row"
          flexWrap="wrap"
          sx={{
            [theme.breakpoints.down("md")]: {
              flexDirection: "column",
            },
          }}
        >
          <StyledLeftBox>
            {isFoundCM || formType !== "add" ? (
              <Box sx={{ mt: "20px" }}>
                <StyledDivider textAlign="left">
                  <Typography variant="subtitle2" sx={{ color: "#949494" }}>
                    Ex Corps Member Profile
                  </Typography>
                </StyledDivider>
                <FormControl sx={{ margin: "20px 10px" }}>
                  {(formType === "edit" || formType === "view") &&
                  showSkeleton ? (
                    <Skeleton
                      variant="rounded"
                      animation="wave"
                      height={40}
                      width={200}
                    />
                  ) : (
                    <TextField
                      id="standard-read-only-input"
                      label="Full Name"
                      value={
                        formType === "add"
                          ? exCM?.cmName
                          : formType === "view" || formType === "edit"
                          ? singleBusinessData?.cmName
                          : ""
                      }
                      InputProps={{
                        readOnly: true,
                      }}
                      variant="standard"
                    />
                  )}
                </FormControl>
                <FormControl sx={{ margin: "20px 10px" }}>
                  {(formType === "edit" || formType === "view") &&
                  showSkeleton ? (
                    <Skeleton
                      variant="rounded"
                      animation="wave"
                      height={40}
                      width={200}
                    />
                  ) : (
                    <TextField
                      id="standard-read-only-input"
                      label={formType !== "add" ? "State Code" : "Course"}
                      value={
                        formType === "add"
                          ? exCM?.course
                          : formType === "view" || formType === "edit"
                          ? singleBusinessData?.stateCode
                          : ""
                      }
                      InputProps={{
                        readOnly: true,
                      }}
                      variant="standard"
                    />
                  )}
                </FormControl>
                {formType === "add" ? (
                  <FormControl sx={{ margin: "20px 10px" }}>
                    <TextField
                      id="standard-read-only-input"
                      label="LGA"
                      value={formType === "add" ? exCM?.lga : ""}
                      InputProps={{
                        readOnly: true,
                      }}
                      variant="standard"
                    />
                  </FormControl>
                ) : (
                  ""
                )}
              </Box>
            ) : formType === "add" ? (
              <img
                src={Image}
                alt=""
                style={{ height: "300px", width: "auto" }}
              />
            ) : (
              "hell0"
            )}
          </StyledLeftBox>
          <div style={StyledRightBox}>
            <StyledDialogTitle id="responsive-dialog-title">
              {formType === "add" ? (
                <span>
                  Add New Business
                  {/*     {" "}
                  <Iconify icon="mdi:draw-pen" /> Add New Business */}
                </span>
              ) : formType === "view" ? (
                "View Business Details"
              ) : formType === "edit" ? (
                "Edit Business Details"
              ) : (
                ""
              )}
              <IconButton onClick={handleCloseDialog}>
                <CloseIcon />
              </IconButton>
            </StyledDialogTitle>
            <Divider />
            <DialogContent
              sx={{ padding: "30px 10px", textTransform: "capitalize" }}
            >
              {formType === "add" ? (
                <HorizontalLinearStepper
                  resetFoundCM={resetFoundCM}
                  isFoundCM={isFoundCM}
                  handleIsFoundCM={handleIsFoundCM}
                  handleResetFoundCM={handleResetFoundCM}
                  handleCloseDialog={handleCloseDialog}
                  isClosedDialog={isClosedDialog}
                  resetState={resetState}
                  showError={showError}
                  showNoError={showNoError}
                  isError={isError}
                />
              ) : formType === "view" || "edit" ? (
                <ViewandEditForm
                  values={values}
                  lgaValues={lgaValues}
                  stateHandler={stateHandler}
                  lgaHandler={lgaHandler}
                  updateValue={updateValue}
                  updateLgaValue={updateLgaValue}
                  checked={checked}
                  formType={formType}
                  singleBusinessData={singleBusinessData}
                  formValues={formValues}
                  handleBusinessUpdate={handleBusinessUpdate}
                  formStates={formStates}
                  handleBlurEmail={handleBlurEmail}
                  showSkeleton={showSkeleton}
                  handleBlurPhoneNumber={handleBlurPhoneNumber}
                />
              ) : (
                ""
              )}
            </DialogContent>
            <Divider />
            {formType === "add" ? (
              ""
            ) : (
              <StyledDialogActions>
                <DialogGreyOutlinedButton
                  sx={{
                    textTransform: "capitalize",
                    // background: "#cde8da91",
                    padding: "10px 30px",
                  }}
                  onClick={handleCloseDialog}
                >
                  close
                </DialogGreyOutlinedButton>
                {formType === "view" &&
                authUser.role !== "SAED_State_Coordinator" ? (
                  <Button
                    onClick={handleEdit}
                    startIcon={<EditIcon icon="icon-park-outline:edit" />}
                    sx={{
                      textTransform: "capitalize",
                      color: colors.primaryYellow,
                      borderColor: colors.primaryYellow,
                      padding: "10px 30px",
                      "&:hover": { borderColor: colors.primaryYellow },
                    }}
                    variant="outlined"
                  >
                    Edit Details
                  </Button>
                ) : formType === "edit" ? (
                  <LoadingButton
                    loading={loadingButton}
                    loadingIndicator="Saving..."
                    onClick={handleFormUpdate}
                    disableElevation
                    startIcon={<SaveAsIcon icon="icon-park-outline:edit" />}
                    sx={{
                      textTransform: "capitalize",
                      color: "#fff",
                      borderColor: colors.primaryGreen,
                      "&:hover": { borderColor: colors.primaryGreen },
                      padding: "10px 30px",
                    }}
                    variant="contained"
                  >
                    Save Changes
                  </LoadingButton>
                ) : (
                  ""
                )}
              </StyledDialogActions>
            )}
          </div>
        </Box>
        <ToastContainer toastStyle={ToastStyle} />
      </Dialog>
    </ThemeProvider>
  );
}
